export default class SearchEngineResponse{
    constructor(data) {
        this.content = data?.hits?.hits?.map(it=>it._source);
    }
}